export default function createPropsForScopusArticle(scopusArticle) {
  const {
    aucite: authors,
    doi,
    pgfirst: firstPage,
    pglast: lastPage,
    pubdatetxt: publicationDate,
    srctitle: publicationName,
    itemtitle: title,
  } = scopusArticle;

  const pageRange = (firstPage && lastPage)
    ? [firstPage, lastPage]
    : [];

  return {
    authors,
    doi,
    pageRange,
    publicationDate,
    publicationName,
    title: title && title[0],
  };
}
